import { render, staticRenderFns } from "./StockTable_custom.vue?vue&type=template&id=d64d66ce&"
import script from "./StockTable_custom.vue?vue&type=script&lang=js&"
export * from "./StockTable_custom.vue?vue&type=script&lang=js&"
import style0 from "./StockTable_custom.vue?vue&type=style&index=0&id=d64d66ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports